

export default class DataHelper {
    geneticsFormData = (data) => {
        const {
            category,
            productType,
            name,
            description,
            time,
            mother,
            father
        } = data;

        let formData = new FormData();

        formData.append('categoryId', category);
        formData.append('type', productType);
        formData.append('name', name);
        formData.append('description', description);
        formData.append('time', time);
        formData.append('mother', mother);
        formData.append('father', father);

        return formData;
    }

    merchandiseFormData = (data) => {
        const {
            category,
            productType,
            name,
            description
        } = data;

        let formData = new FormData();

        formData.append('categoryId', category);
        formData.append('type', productType);
        formData.append('name', name);
        formData.append('description', description);

        return formData;
    }
}